import React, { useEffect, useState } from "react";
import "./About.css";
import profilePic from "../../../images/Github-profile-pic.png";
import resumeSrc from "../../../images/Md Jahidul Islam - Resume.pdf";
import GetAppIcon from "@material-ui/icons/GetApp";

const About = () => {
  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 300);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="about">
      <div className="container-fluid">
        <div className="scroll-text">
          <p className="" style={{ transform: `translateX(${scroll}%)` }}>
            ABOUT
          </p>
        </div>
        <h2
          style={{
            color: "#00ffd5",
            textAlign: "center",
            marginTop: "-54px",
            marginBottom: "60px",
            fontSize: "36px",
            position: "relative",
            zIndex: 2,
          }}
        >
          ABOUT ME
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "16px",
              zIndex: 9999,
            }}
          >
            <div className="main">
              <div className="ball"></div>
            </div>
          </div>
        </h2>

        <div
          className="row"
          style={{
            // maxWidth: "1300px", margin: "auto",
            position: "relative",
            zIndex: 4,
            padding: "24px 16px",
            backgroundColor: "#241b2f",
            borderRadius: "8px",
          }}
        >
          <div
            className="col col-md-4 p-3 d-flex justify-content-center"
            style={{ padding: "0px" }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
          >
            {/* <img className="profile mb-4" src={profilePic} alt="" /> */}
            <div
              className="row"
              style={{
                backgroundColor: "#262335",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <div className="col-md-12 contact-details">
                <h2 style={{ color: "#00ffd5" }}>Contact Details</h2>
                <p className="address" style={{ color: "white" }}>
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Name
                      </strong>{" "}
                      : Md Jahidul Islam <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Location
                      </strong>{" "}
                      : Dhaka, Bangladesh <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Languages
                      </strong>{" "}
                      : English, Bengali <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Full-time
                      </strong>{" "}
                      : preferred <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Freelance
                      </strong>{" "}
                      : Available <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Mobile
                      </strong>{" "}
                      : +880 1938901990 <br />
                    </div>
                    <div>
                      <strong className="left-column">
                        {" "}
                        <span>&bull;</span> Email{" "}
                      </strong>{" "}
                      : za0162hid@gmail.com <br />
                    </div>
                  </div>
                </p>
              </div>
              <div className=" col col-md-6 col-sm-12 download">
                <p className=" download-button ml-md-auto">
                  <a href={resumeSrc} className="text-white" download>
                    <GetAppIcon /> Download Resume
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div
            className="col col-md-8 pl-3"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
          >
            {/* <h2 style={{ color: "#00ffd5" }}> About Me </h2> */}
            <h1 className="about-headline ">
              I am a
              <span className="about-animated-text">Software Engineer</span>
            </h1>
            <p className="text-justify" style={{ color: "white" }}>
              I'm a Full Stack Web Developer with 3+ years of experience
              designing and building responsive, high-performance websites and
              web applications.
              <br />
              <br />
              My Expertise:
              <br />
              - Website & web app development using React.js, Next.js, Node.js,
              and Express.js.
              <br />
              - Experience with MongoDB, Firebase/Firestore, and building
              RESTful APIs.
              <br />
              - Strong grasp of SEO best practices - on-page SEO, meta tags &
              schema, sitemap & robots.txt, page speed optimization.
              <br />
              - Business analysis - gathering client requirements and
              translating them into technical specifications.
              <br />
              - Styling with Tailwind CSS, Bootstrap, and Material UI.
              <br />
              - Mastery of Git, GitHub, NPM, VS Code, and Postman.
              <br />
              <br />I look forward to making a long-term relationship.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
